var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
            [
              _c(
                "b-form-group",
                { staticClass: "mb-0" },
                [
                  _c(
                    "label",
                    { staticClass: "d-inline-block text-sm-left mr-50" },
                    [_vm._v("Per page")]
                  ),
                  _c("b-form-select", {
                    staticClass: "w-50",
                    attrs: {
                      id: "perPageSelect",
                      size: "sm",
                      options: _vm.pageOptions,
                    },
                    model: {
                      value: _vm.perPage,
                      callback: function ($$v) {
                        _vm.perPage = $$v
                      },
                      expression: "perPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("b-col", { staticClass: "my-1", attrs: { md: "4", sm: "8" } }),
          _c(
            "b-col",
            { staticClass: "my-1", attrs: { md: "6" } },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: {
                    label: "Filter",
                    "label-cols-sm": "3",
                    "label-align-sm": "right",
                    "label-size": "sm",
                    "label-for": "filterInput",
                  },
                },
                [
                  _c(
                    "b-input-group",
                    { attrs: { size: "sm" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "filterInput",
                          type: "search",
                          placeholder: "Type to Search",
                        },
                        model: {
                          value: _vm.filter,
                          callback: function ($$v) {
                            _vm.filter = $$v
                          },
                          expression: "filter",
                        },
                      }),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { disabled: !_vm.filter },
                              on: {
                                click: function ($event) {
                                  _vm.filter = ""
                                },
                              },
                            },
                            [_vm._v(" Clear ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-table", {
        attrs: {
          items: _vm.logs,
          fields: _vm.fields,
          striped: "",
          responsive: "",
          "per-page": _vm.perPage,
          "current-page": _vm.currentPage,
          "sort-by": _vm.sortBy,
          "sort-desc": _vm.sortDesc,
          "sort-direction": _vm.sortDirection,
          filter: _vm.filter,
          "filter-included-fields": _vm.filterOn,
        },
        on: {
          "update:sortBy": function ($event) {
            _vm.sortBy = $event
          },
          "update:sort-by": function ($event) {
            _vm.sortBy = $event
          },
          "update:sortDesc": function ($event) {
            _vm.sortDesc = $event
          },
          "update:sort-desc": function ($event) {
            _vm.sortDesc = $event
          },
          filtered: _vm.onFiltered,
        },
        scopedSlots: _vm._u([
          {
            key: "cell(show_details)",
            fn: function (row) {
              return [
                _c(
                  "b-form-checkbox",
                  {
                    staticClass: "vs-checkbox-con",
                    attrs: { plain: "" },
                    on: { change: row.toggleDetails },
                    model: {
                      value: row.detailsShowing,
                      callback: function ($$v) {
                        _vm.$set(row, "detailsShowing", $$v)
                      },
                      expression: "row.detailsShowing",
                    },
                  },
                  [
                    _c("span", { staticClass: "vs-checkbox" }, [
                      _c("span", { staticClass: "vs-checkbox--check" }, [
                        _c("i", { staticClass: "vs-icon feather icon-check" }),
                      ]),
                    ]),
                    _c("span", { staticClass: "vs-label" }, [
                      _vm._v(_vm._s(row.detailsShowing ? "Hide" : "Show")),
                    ]),
                  ]
                ),
              ]
            },
          },
          {
            key: "row-details",
            fn: function (row) {
              return [
                _c(
                  "b-card",
                  [
                    _c(
                      "b-row",
                      { staticClass: "mb-2" },
                      [
                        row.item.oldValue == null
                          ? _c(
                              "b-col",
                              { staticClass: "mb-1", attrs: { md: "12" } },
                              [
                                _c("strong", [_vm._v("Old Values: ")]),
                                _vm._v("No Old Values "),
                              ]
                            )
                          : _vm._e(),
                        row.item.oldValue !== null
                          ? _c(
                              "b-col",
                              { staticClass: "mb-1", attrs: { md: "12" } },
                              [
                                _c("strong", [_vm._v("Old Values: ")]),
                                _c("b-table", {
                                  attrs: {
                                    items: _vm.beautifyJson(row.item.oldValue),
                                    fields: ["key", "value"],
                                    bordered: "",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "b-col",
                          { staticClass: "mb-1", attrs: { md: "12" } },
                          [
                            _c("strong", [_vm._v("New Values: ")]),
                            _c("b-table", {
                              attrs: {
                                items: _vm.beautifyJson(row.item.newValue),
                                fields: ["key", "value"],
                                bordered: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c("b-pagination", {
        staticClass: "my-0",
        attrs: {
          "total-rows": _vm.totalRows,
          "per-page": _vm.perPage,
          align: "center",
          size: "sm",
        },
        model: {
          value: _vm.currentPage,
          callback: function ($$v) {
            _vm.currentPage = $$v
          },
          expression: "currentPage",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }